import type {AxiosError} from "axios";

import {isVehicleWrongPropertyContextError} from "@/src/modules/vehicles/lib/is-vehicle-wrong-property-context-error";

import {captureTaggedException} from "./capture";
import {resolveErrorCode} from "./error-codes";
import {shouldCaptureAxiosError} from "./should-capture-axios";

/** Submit-path capture — aligned with global axios policy (4xx warning, 5xx/network error). */
export function shouldCaptureDomainSubmitError(error: unknown): boolean {
  if (isVehicleWrongPropertyContextError(error)) return false;
  return shouldCaptureAxiosError(error);
}

export function captureDomainSubmitError(
  error: unknown,
  input: {feature: string; operation: string},
): void {
  if (!shouldCaptureDomainSubmitError(error)) return;

  const axiosError = error as AxiosError;
  const errorCode = resolveErrorCode(error);

  captureTaggedException(error, {
    feature: input.feature,
    errorCode,
    operation: input.operation,
    errorSource: "domain",
    axiosError,
    useMessageTitle: true,
  });
}

/** @deprecated Use `captureDomainSubmitError`. */
export const shouldCaptureParkingError = shouldCaptureDomainSubmitError;

/** @deprecated Use `captureDomainSubmitError`. */
export const captureParkingSubmitError = captureDomainSubmitError;
